import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Module, ModulePreference } from '@thro-types/modules-selections';

import { FieldArrayRenderProps, useFormikContext } from 'formik';

export const PickableModules = ({
  position,
  index,
  selectableModules,
  arrayHelpers
}: {
  position: number;
  index: number;
  selectableModules: Module[];
  arrayHelpers: Pick<
    FieldArrayRenderProps,
    'move' | 'swap' | 'push' | 'insert' | 'unshift' | 'pop' | 'remove'
  >;
}) => {
  const { values, setFieldValue } = useFormikContext<{ modulePreferences: ModulePreference[] }>();

  let isDisabled = index !== 0 ? !values?.modulePreferences?.[index - 1] : false;

  const value =
    values.modulePreferences &&
    selectableModules.find(toFind => values.modulePreferences[index]?.moduleId === toFind.id);

  const options = selectableModules.map(module => {
    return { moduleId: module.id, label: module.name, isTakingPlace: module.isTakingPlace };
  });

  return (
    <Grid item container alignItems="center">
      <Typography style={{ fontWeight: 'bold', minWidth: '2em' }}>{position + '.'}</Typography>
      <Grid item xs container>
        <Autocomplete
          fullWidth
          value={(value && options.find(o => o.moduleId === value.id)) || null}
          isOptionEqualToValue={(option, value) => option?.moduleId === value?.moduleId}
          getOptionLabel={option => (option.label ? option.label : '')}
          getOptionDisabled={option => {
            return (
              !option.isTakingPlace ||
              values?.modulePreferences?.filter(cm => {
                return cm.moduleId === option.moduleId;
              }).length > 0
            );
          }}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              {!option.isTakingPlace && <DoNotDisturbAltIcon color="error" />}
              {option.label}
            </Box>
          )}
          disabled={isDisabled}
          renderInput={params => (
            <TextField
              {...params}
              style={{ backgroundColor: isDisabled ? '#f2f2f2' : '#FFFFFF' }}
            />
          )}
          onChange={async (event, value, reason) => {
            if (!value) {
              arrayHelpers.remove(index);
              const filtered = values.modulePreferences.filter(mp => mp.rank !== position);
              await setFieldValue('modulePreferences', filtered);
              for (let i = 0; i < filtered.length; i++) {
                await setFieldValue(`modulePreferences[${i}]`, {
                  moduleId: filtered[i].moduleId,
                  rank: i + 1
                });
              }
              return;
            }
            await setFieldValue(`modulePreferences[${index}]`, {
              moduleId: value?.moduleId,
              rank: position
            });
          }}
          options={options}
        />
      </Grid>
    </Grid>
  );
};
